<template>
  <div class="flex justify-between items-start gap-4 mt-1 text-sm">
    <span v-if="isOverLimit" class="text-orange-600">
      Warning: Longer Alert messages may be truncated on some mobile platforms when send as SMS text messages.
    </span>
    <span
      class="ml-auto whitespace-nowrap"
      :class="isOverLimit ? 'text-orange-600 font-medium' : 'text-gray-500'"
      title="Characters ^ { } [ ] ~ \ | € count as 2"
    >
      {{ count }}/{{ limit }}
      <span v-if="parts > 0">({{ parts }} SMS part{{ parts === 1 ? "" : "s" }})</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { gsmLength, gsmMaxCharsForParts, gsmPartCount } from "../helpers/gsm";

const props = withDefaults(
  defineProps<{
    message: string | null | undefined;
    limit?: number;
  }>(),
  { limit: gsmMaxCharsForParts(3) }
);

// Billed GSM count: extension chars (^ { } [ ] ~ \ | €) count as 2
const count = computed(() => gsmLength(props.message));
const parts = computed(() => gsmPartCount(props.message));
const isOverLimit = computed(() => count.value > props.limit);
</script>
